import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import { createReducer } from 'redux-act';
import { getYodleeTopTakeaways } from "../../actions/yodlee";
export default createReducer(_defineProperty({}, getYodleeTopTakeaways.success, function (state, payload) {
  return _get(payload, 'top_takeaways');
}), null);